<template>
  <div>
    <filters :selected-lesson.sync="lesson" :selected-from-date.sync="from" :selected-to-date.sync="to"></filters>
    <div style="min-height: 200px;" v-if="isLoading">
      <b-loading :is-full-page="false" :active="isLoading" :can-cancel="false"></b-loading>
    </div>
    <div  v-else>
      <div class="columns is-centered">
        <div class="column is-narrow">
          <b-field grouped group-multiline>
            <div class="control">
              <b-taglist attached>
                <b-tag type="is-dark" >Promedio</b-tag>
                <b-tag type="is-light">{{this.avg}}%</b-tag>
              </b-taglist>
            </div>
            <div class="control">
              <b-taglist attached>
                <b-tag type="is-dark">Desviación Estandar</b-tag> <br>
                <b-tag type="is-light">{{this.standardDeviation.toFixed(2)}}</b-tag>
              </b-taglist>
            </div>
            <div class="control">
              <b-taglist attached>
                <b-tag type="is-dark">Varianza</b-tag>
                <b-tag type="is-light">{{this.variance.toFixed(2)}}</b-tag>
              </b-taglist>
            </div>
            <div class="control">
              <b-taglist attached>
                <b-tag type="is-dark">Nota Max.</b-tag>
                <b-tag type="is-light">{{this.maxScore.toFixed(2)}}</b-tag>
              </b-taglist>
            </div>
            <div class="control">
              <b-taglist attached>
                <b-tag type="is-dark">Nota Min.</b-tag>
                <b-tag type="is-light">{{this.minScore.toFixed(2)}}</b-tag>
              </b-taglist>
            </div>
            <div class="control">
              <b-taglist attached>
                <b-tag type="is-dark">Pendiente</b-tag>
                <b-tag type="is-light">{{this.slope ? this.slope.toFixed(2) : 0}}</b-tag>
              </b-taglist>
            </div>
          </b-field>
        </div>
      </div>
      <div class="columns is-centered">
        <div class="column is-narrow">
          <b-field grouped group-multiline>
            <div class="control">
              <b-taglist attached>
                <b-tag type="is-dark">Tiempo Transcurrido</b-tag>
                <b-tag type="is-light">{{timeLapse}}</b-tag>
              </b-taglist>
            </div>
            <div class="control">
              <b-taglist attached>
                <b-tag type="is-dark">Lecciones</b-tag>
                <b-tag type="is-light">{{evaluations.length}}</b-tag>
              </b-taglist>
            </div>
          </b-field>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <bar-label-chart slot="content"  class="chart-height" v-if="!isLoading"
          :chart-data="defaultChart.chartData"
                        :extra-options="defaultChart.extraOptions"
          ></bar-label-chart>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as chartConfig from '@/components/Charts/chart.config'
import BarLabelChart from '@/components/Charts/BarLabelChart'
import ResultBinomialService from '@/services/ResultBinomialService'
import Filters from '@/components/Filters'

export default {
  components: {
    BarLabelChart,
    Filters
  },
  props: {
    horseId: {
      required: true
    }
  },
  created () {
    let today = new Date()
    let from = new Date().setMonth(today.getMonth() - 1)
    this.to = today
    this.from = new Date(from)
    this.getExecutions()
  },
  data () {
    return {
      evaluations: [],
      defaultChart: {
        chartData: {},
        extraOptions: {
          ...chartConfig.chartOptionsMain,
          scales: {
            yAxes: [{
              ticks: {
                max: 100,
                min: 0,
                stepSize: 10
              }
            }]
          }
        }
      },
      isLoading: false,
      labels: [],
      scores: [],
      from: null,
      to: null,
      lesson: 0,
      avg: 0,
      avgArr: [],
      variance: 0,
      standardDeviation: 0,
      negativeSD: [],
      positiveSD: [],
      tendency: [],
      maxScore: 0,
      minScore: 0,
      slope: 0
    }
  },
  methods: {
    async getExecutions () {
      this.isLoading = true

      let param = {
        horse_id: this.horseId,
        lesson_id: this.lesson,
        from: this.from,
        to: this.to
      }
      let response = await ResultBinomialService.getResultsBinomial(param)
      this.evaluations = response.data.data
      this.mapData()
      this.initChartData()
      this.isLoading = false
    },
    mapData () {
      this.avgArr = []
      this.negativeSD = []
      this.positiveSD = []
      this.scores = []
      this.labels = []
      this.tendency = []
      this.avg = 0
      this.maxScore = 0
      this.minScore = 0
      let totalScore = 0
      let totalX = 0
      let totalXY = 0
      let totalPowX = 0
      let numberScores = this.evaluations.length

      for (let index = 0; index < this.evaluations.length; index++) {
        let evaluation = this.evaluations[index]
        let score = parseFloat(evaluation.final_score)
        let x = index + 1
        totalScore += score
        totalX += x
        let xy = x * score
        totalXY += xy
        let powX = Math.pow(x, 2)
        totalPowX += powX

        if (this.maxScore === 0 && this.minScore === 0) {
          this.maxScore = score
          this.minScore = score
        }
        if (score > this.maxScore) {
          this.maxScore = score
        }
        if (score < this.minScore) {
          this.minScore = score
        }
        this.scores[index] = score.toFixed(2)
      }

      this.avg = (totalScore / this.evaluations.length).toFixed(2)

      this.slope = ((numberScores * totalXY) - totalX * totalScore) / ((numberScores * totalPowX) - Math.pow(totalX, 2))
      let b = (totalScore / numberScores) - (this.slope * (totalX / numberScores))

      let summation = 0

      for (let index = 0; index < this.evaluations.length; index++) {
        let evaluation = this.evaluations[index]
        summation += Math.pow((evaluation.final_score - this.avg), 2)
      }

      this.variance = Number.parseFloat(summation) / this.evaluations.length
      this.standardDeviation = Math.sqrt(this.variance)

      for (let index = 0; index < this.evaluations.length; index++) {
        let evaluation = this.evaluations[index]
        this.labels[index] = [
          `${evaluation.rider_lastname} ${evaluation.rider_name}`,
          `${this.$moment(evaluation.execution_date, 'YYYY-MM-DD').format('L')}`
        ]
        let x = index + 1
        this.tendency[index] = ((this.slope * x) + b).toFixed(2)
        this.negativeSD[index] = (this.avg - this.standardDeviation).toFixed(2)
        this.positiveSD[index] = (Number.parseFloat(this.avg) + Number.parseFloat(this.standardDeviation)).toFixed(2)
        this.avgArr[index] = this.avg
      }
    },
    initChartData () {
      this.defaultChart.chartData = {
        datasets: [
          {
            label: 'Promedio',
            data: this.avgArr,
            fill: false,
            borderWidth: 4,
            borderColor: 'rgba(244,67,54,0.6)',
            type: 'line',
            datalabels: {
              opacity: 0
            }
          },
          {
            label: 'Desviación Positiva',
            data: this.positiveSD,
            fill: false,
            borderWidth: 4,
            borderColor: 'rgba(3,169,244,0.6)',
            type: 'line',
            datalabels: {
              opacity: 0
            }
          },
          {
            label: 'Desviación negativa',
            data: this.negativeSD,
            fill: false,
            borderWidth: 4,
            borderColor: 'rgba(3,169,244,0.6)',
            type: 'line',
            datalabels: {
              opacity: 0
            }
          },
          {
            label: 'Tendencia',
            data: this.tendency,
            fill: false,
            borderWidth: 4,
            borderColor: 'rgba(156,39,176,0.6)',
            type: 'line',
            datalabels: {
              opacity: 0
            }
          },
          {
            maxBarThickness: 20,
            backgroundColor: chartConfig.chartColors.default.primary,
            data: this.scores,
            label: 'Evaluaciones',
            datalabels: {
              display: true,
              align: 'top',
              offset: 5,
              anchor: 'end',
              borderRadius: 3,
              color: 'black',
              rotation: 75,
              font: {
                size: 12
              }
            }
          }
        ],
        labels: this.labels
      }
    }
  },
  computed: {
    timeLapse () {
      let diff = 0
      if (this.evaluations.length === 1) {
        let firstDate = this.$moment(this.evaluations[0].execution_date, 'YYYY-MM-DD')
        let lastDate = this.$moment(this.evaluations[0].execution_date, 'YYYY-MM-DD')
        diff = firstDate.diff(lastDate)
      } else if (this.evaluations.length > 1) {
        let firstDate = this.$moment(this.evaluations[0].execution_date, 'YYYY-MM-DD')
        let lastDate = this.$moment(this.evaluations[this.evaluations.length - 1].execution_date, 'YYYY-MM-DD')
        diff = firstDate.diff(lastDate)
      }
      return diff !== 0 ? this.$moment.duration(diff).humanize() : 'Faltan más datos'
    }
  },
  watch: {
    lesson (value) {
      this.getExecutions()
    },
    from (value) {
      this.getExecutions()
    },
    to (value) {
      this.getExecutions()
    }
  }

}
</script>

<style scoped>
  .chart-height{
    height: 100%;
  }

  .tags-container{
    padding-top: 3rem;
  }

  .avg{
    background-color: rgba(244,67,54,0.5) !important;
  }

  .standard-deviation{
    background-color: rgba(33,150,243,0.5) !important;
  }
</style>
